<template>
    <rkm-area
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="12">

                <rkm-table
                    :fields="fields"
                    :items="items"
                    sort-by="nome"
                    hide-filters
                >
                    <template v-slot:cell(cns)="row">
                        {{ row.value | formatCns }}
                    </template>

                    <template v-slot:cell(imc)="{ item }">
                        <span v-if="item.imc">
                            {{ item.imc }} <small class="text-muted">{{ item.imcClassificacao }}</small>
                        </span>
                        <span v-else>-</span>
                    </template>

                    <template v-slot:cell(procedimento)="{ index, item }" >
                        <rkm-button
                            @click="$refs.ModalParticipante.open(index, item)"
                            class="mr-2"
                            color="primary"
                            small
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click="destroy(item.id)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <ModalParticipante
            :data="{ form, model }"
            ref="ModalParticipante"
            @procedimentosIndividuais="procedimentosIndividuais"
        />
    </rkm-area>
</template>

<script>
//Modal
import ModalParticipante from './Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins
import { repository, error, object, data, stringCase } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    components: {
        ModalParticipante
    },
    computed: {
        fields() {
            const fields = [
                {
                    key: "nome",
                    label: "Nome"
                },
                {
                    key: "cns",
                    label: "CNS"
                },
                {
                    key: "avaliacaoAlterada",
                    label: "Alterada",
                    class: "text-center"
                },
                {
                    key: "peso",
                    label: "Peso (kg)",
                    class: "text-center"
                },
                {
                    key: "altura",
                    label: "Altura (cm)",
                    class: "text-center"
                },
                {
                    key: "imc",
                    label: "IMC",
                    class: "text-center"
                },
                {
                    key: "afericaoPa",
                    label: "PA (mmHg)",
                    class: "text-center"
                },
                {
                    key: "glicemiaCapilar",
                    label: "Glicemia (mg/dL)",
                    class: "text-center"
                },
                {
                    key: "parouFumar",
                    label: "Parou de fumar",
                    class: "text-center"
                },
                {
                    key: "abandonouGrupo",
                    label: "Abandonou grupo",
                    class: "text-center"
                },
                {
                    key: "procedimento",
                    label: "Procedimento(s)",
                    class: "col-1 text-center"
                },
                {
                    key: "actions",
                    label: "Ação",
                    class: "col-1 text-center"
                }
            ]

            return fields
        },
        items() {
            return this.data.model.participantes ?? []
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        procedimentosIndividuais(procedimentos) {
            this.$emit('procedimentosIndividuais', procedimentos)
        },
        destroy(participanteId) {

            const index = this.data.model.participantes.findIndex(participante => participante.id === participanteId)


            const avaliacaoAlterada = this.data.model.participantes[index].avaliacaoAlterada

            if(avaliacaoAlterada == 'Sim'){
                const destroy = async () => { this.data.model.participantes.splice(index, 1),  this.data.model.atividade.avaliacoesAlteradas -= 1 }
                this.showDeleteConfirmation('Deseja realmente excluir o participante?', destroy)
            }else{
                const destroy = async () =>  this.data.model.participantes.splice(index, 1)
                this.showDeleteConfirmation('Deseja realmente excluir o participante?', destroy)
            }





        }
    },
    data() {
        return {
            model: {
                procedimentosIndividuais: this.data.model.procedimentosIndividuais ?? [],
                searchByApelido: false,
            },
            form: null,
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    filters: {
        formatCns: formats.formatCns,
    },
    props: {
        data: { type: Object, required: false },
        id: { type: Number },
        index: { type: Number, default: null },
    },
}
</script>